const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                    ['meta_content', [this, 'block_meta_content']],
                    ['avatars', [this, 'block_avatars']],
                    ['authors', [this, 'block_authors']]
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.startOutputBuffer();
                this.echo(`  `);
                this.traceableDisplayBlock(9, this.source)('meta_content', context.clone(), blocks);
                context.proxy[`_meta_content`] = (() => {let tmp = this.getAndCleanOutputBuffer(); return tmp === '' ? '' : new this.Markup(tmp, this.env.getCharset());})();
                this.echo(`
`);
                this.startOutputBuffer();
                this.echo(`  `);
                this.traceableDisplayBlock(44, this.source)('avatars', context.clone(), blocks);
                context.proxy[`_avatars`] = (() => {let tmp = this.getAndCleanOutputBuffer(); return tmp === '' ? '' : new this.Markup(tmp, this.env.getCharset());})();
                this.echo(`
<div class="c-author o-media`);
                if ((context.has(`class`) ? context.get(`class`) : null)) {
                    this.echo(` `);
                    this.echo(this.env.getFilter('escape').traceableCallable(51, this.source)(...[this.env, (context.has(`class`) ? context.get(`class`) : null), `html`, null, true]));
                }
                this.echo(`">
  `);
                this.echo(`  `);
                this.echo(this.include(context, this.source, this.loadTemplate(`e51244f53a14fa1c5aa372a7b845845a867ce1ecbf96379df6aa70b546129178`, `e51244f53a14fa1c5aa372a7b845845a867ce1ecbf96379df6aa70b546129178`, 53, 132), new Map([[`class`, `o-media__object`], [`_avatars`, (context.has(`_avatars`) ? context.get(`_avatars`) : null)]]), false, false, 53));
                this.echo(`
  `);
                this.echo(`  <div class="c-author__content-container o-media__content">
    `);
                this.echo(`    <p class="c-author__author">
      <span class="u-hidden-visually">`);
                this.echo(this.env.getFilter('escape').traceableCallable(66, this.source)(...[this.env, (((context.has(`author_prefix`))) ? (this.env.getFilter('default').traceableCallable(66, this.source)(...[(context.has(`author_prefix`) ? context.get(`author_prefix`) : null), `By`])) : (`By`)), `html`, null, true]));
                this.echo(`</span>
      `);
                this.traceableDisplayBlock(67, this.source)('authors', context.clone(), blocks);
                this.echo(`    </p>

    `);
                this.echo(`    `);
                if (this.env.getFilter('trim').traceableCallable(81, this.source)(...[(context.has(`_meta_content`) ? context.get(`_meta_content`) : null)])) {
                    this.echo(`      <div class="c-author__meta">
        `);
                    this.echo(this.env.getFilter('escape').traceableCallable(83, this.source)(...[this.env, (context.has(`_meta_content`) ? context.get(`_meta_content`) : null), `html`, null, true]));
                    this.echo(`
      </div>
    `);
                }
                this.echo(`  </div>
</div>
`);
            }

            block_meta_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                if ((context.has(`meta`) ? context.get(`meta`) : null)) {
                    this.echo(`      <p>`);
                    this.echo(this.env.getFilter('escape').traceableCallable(11, this.source)(...[this.env, (context.has(`meta`) ? context.get(`meta`) : null), `html`, null, true]));
                    this.echo(`</p>
    `);
                }
                else if ((context.has(`date`) ? context.get(`date`) : null)) {
                    this.echo(`      <p>
        `);
                    this.echo(`        <span class="u-hidden-visually">
          `);
                    this.echo(this.env.getFilter('escape').traceableCallable(16, this.source)(...[this.env, (((context.has(`date_prefix`))) ? (this.env.getFilter('default').traceableCallable(16, this.source)(...[(context.has(`date_prefix`) ? context.get(`date_prefix`) : null), `Published on`])) : (`Published on`)), `html`, null, true]));
                    this.echo(` `);
                    this.echo(this.env.getFilter('escape').traceableCallable(16, this.source)(...[this.env, this.env.getFilter('date').traceableCallable(16, this.source)(...[this.env, (context.has(`date`) ? context.get(`date`) : null), `F jS, Y`]), `html`, null, true]));
                    this.echo(`
        </span>
        `);
                    this.echo(`        <time aria-hidden="true" datetime="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(35, this.source)(...[this.env, this.env.getFilter('date').traceableCallable(35, this.source)(...[this.env, (context.has(`date`) ? context.get(`date`) : null), `Y-m-d`]), `html`, null, true]));
                    this.echo(`">
          `);
                    this.echo(this.env.getFilter('escape').traceableCallable(36, this.source)(...[this.env, ((this.compare((context.has(`date_format`) ? context.get(`date_format`) : null), `short`)) ? (this.env.getFilter('date').traceableCallable(36, this.source)(...[this.env, (context.has(`date`) ? context.get(`date`) : null), `M j, Y`])) : (this.env.getFilter('date').traceableCallable(36, this.source)(...[this.env, (context.has(`date`) ? context.get(`date`) : null), `F jS, Y`]))), `html`, null, true]));
                    this.echo(`
        </time>
      </p>
    `);
                }
                this.echo(`  `);
            }

            block_avatars(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable((context.has(`authors`) ? context.get(`authors`) : null));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`author`] = __value__;
                    this.echo(`      `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/avatar/avatar.twig`, new Map([[`src`, this.traceableMethod(this.getAttribute, 46, this.source)(this.env, context.get(`author`), `avatar`, new Map([]), `any`, false, false, false)]]), false, false, 46));
                    this.echo(`    `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('author');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`  `);
            }

            block_authors(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable((context.has(`authors`) ? context.get(`authors`) : null));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                context.set('loop', new Map([
                  ['parent', context.get('_parent')],
                  ['index0', 0],
                  ['index', 1],
                  ['first', true]
                ]));
                if ((typeof context.get('_seq') === 'object') && this.isCountable(context.get('_seq'))) {
                    let length = this.count(context.get('_seq'));
                    let loop = context.get('loop');
                    loop.set('revindex0', length - 1);
                    loop.set('revindex', length);
                    loop.set('length', length);
                    loop.set('last', (length === 1));
                }
                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`author`] = __value__;
                    this.echo(`          `);
                    if (!!(this.traceableMethod(this.getAttribute, 69, this.source)(this.env, context.get(`loop`), `last`, new Map([]), `any`, false, false, false) && (this.traceableMethod(this.getAttribute, 69, this.source)(this.env, context.get(`loop`), `length`, new Map([]), `any`, false, false, false) > 1))) {
                        this.echo(`and `);
                    }
                    if (!!(this.traceableMethod(this.getAttribute, 70, this.source)(this.env, context.get(`author`), `link`, new Map([]), `any`, false, false, false) &&  !(context.has(`unlink`) ? context.get(`unlink`) : null))) {
                        this.echo(`<a href="`);
                        this.echo(this.env.getFilter('escape').traceableCallable(71, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 71, this.source)(this.env, context.get(`author`), `link`, new Map([]), `any`, false, false, false), `html`, null, true]));
                        this.echo(`">`);
                        this.echo(this.env.getFilter('escape').traceableCallable(71, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 71, this.source)(this.env, context.get(`author`), `name`, new Map([]), `any`, false, false, false), `html`, null, true]));
                        this.echo(`</a>`);
                    }
                    else {
                        this.echo(`<span>`);
                        this.echo(this.env.getFilter('escape').traceableCallable(73, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 73, this.source)(this.env, context.get(`author`), `name`, new Map([]), `any`, false, false, false), `html`, null, true]));
                        this.echo(`</span>`);
                    }
                    if (!!( !this.traceableMethod(this.getAttribute, 75, this.source)(this.env, context.get(`loop`), `last`, new Map([]), `any`, false, false, false) && (this.traceableMethod(this.getAttribute, 75, this.source)(this.env, context.get(`loop`), `length`, new Map([]), `any`, false, false, false) > 2))) {
                        this.echo(`,`);
                    }
                    this.echo(`        `);
                    (() => {
                        let loop = context.get('loop');
                        loop.set('index0', loop.get('index0') + 1);
                        loop.set('index', loop.get('index') + 1);
                        loop.set('first', false);
                        if (loop.has('length')) {
                            loop.set('revindex0', loop.get('revindex0') - 1);
                            loop.set('revindex', loop.get('revindex') - 1);
                            loop.set('last', loop.get('revindex0') === 0);
                        }
                    })();
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('author');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`      `);
            }

            getTemplateName() {
                return `e51244f53a14fa1c5aa372a7b845845a867ce1ecbf96379df6aa70b546129178`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e51244f53a14fa1c5aa372a7b845845a867ce1ecbf96379df6aa70b546129178`, ``);
            }
        }],
        [132, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/bunch/bunch.twig`, `e51244f53a14fa1c5aa372a7b845845a867ce1ecbf96379df6aa70b546129178`, 53);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/bunch/bunch.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      `);
                this.echo(this.env.getFilter('escape').traceableCallable(58, this.source)(...[this.env, (context.has(`_avatars`) ? context.get(`_avatars`) : null), `html`, null, true]));
                this.echo(`
    `);
            }

            getTemplateName() {
                return `e51244f53a14fa1c5aa372a7b845845a867ce1ecbf96379df6aa70b546129178`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e51244f53a14fa1c5aa372a7b845845a867ce1ecbf96379df6aa70b546129178`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'e51244f53a14fa1c5aa372a7b845845a867ce1ecbf96379df6aa70b546129178');

let template = env.loadTemplate('e51244f53a14fa1c5aa372a7b845845a867ce1ecbf96379df6aa70b546129178');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/author/author.twig", args: context }
     );
     return rendered;;
};